import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { useTrackerPins } from '@/stores/trackerPins';

/**
 * #943 — central mount for the per-user tracker pins. Lives in the app shell,
 * not the tracker: Pull All reads pins from the dashboard, so the list must be
 * loaded there too.
 */
export function useTrackerPinsLifecycle(): void {
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const hydrateFor = useTrackerPins((s) => s.hydrateFor);

  useEffect(() => {
    hydrateFor(userId);
  }, [userId, hydrateFor]);
}
